/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CatalogCreateCatalogRequest = {
  category: CatalogCreateCatalogRequest.category;
  title?: string;
  sub_title?: string;
  page_count: number;
  image_id?: number;
  catalog_url?: string;
};

export namespace CatalogCreateCatalogRequest {
  export enum category {
    SCIENCE = "science",
    HEALTH = "health",
    FACILITIES = "facilities",
  }
}
